import { createTheme } from '@mui/material/styles';
// import getAppConfig from '../config/app-config';

// const config = getAppConfig();

// Definizione delle palette per ogni cliente
const palettes = {
  artyou: {
    primary: {
      main: '#2b3c36',            // Verde scuro Assetto Teatro
      light: '#4e625d',
      dark: '#1c2924',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c4453d',            // Rosso tendaggio
      light: '#d86a62',
      dark: '#912e29',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f4efe9',         // Ocra chiarissimo
      paper: '#ffffff',
    },
    text: {
      primary: '#2b2b2b',         // Neutro scuro
      secondary: '#5f5f5f',       // Grigio caldo
    },
    success: {
      main: '#5f8a3b',            // Verde oliva
      light: '#8dbd63',
      dark: '#3e5c29',
    },
    warning: {
      main: '#e08b27',            // Ocra brillante
      light: '#ffc766',
      dark: '#ab6312',
    },
    error: {
      main: '#b33c3c',            // Rosso vintage
      light: '#e06666',
      dark: '#801b1b',
    },
  },
  assettoteatro: {
    primary: {
      main: '#2b3c36',            // Verde scuro Assetto Teatro
      light: '#4e625d',
      dark: '#1c2924',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c4453d',            // Rosso tendaggio
      light: '#d86a62',
      dark: '#912e29',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f4efe9',         // Ocra chiarissimo
      paper: '#ffffff',
    },
    text: {
      primary: '#2b2b2b',         // Neutro scuro
      secondary: '#5f5f5f',       // Grigio caldo
    },
    success: {
      main: '#5f8a3b',            // Verde oliva
      light: '#8dbd63',
      dark: '#3e5c29',
    },
    warning: {
      main: '#e08b27',            // Ocra brillante
      light: '#ffc766',
      dark: '#ab6312',
    },
    error: {
      main: '#b33c3c',            // Rosso vintage
      light: '#e06666',
      dark: '#801b1b',
    },
  },
  darsena: {
    primary: {
      main: '#45B7D1',            // Blu Darsena
      light: '#6bc5d9',
      dark: '#2d8ba3',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F39C12',            // Arancione complementare
      light: '#f7b84d',
      dark: '#d68910',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ecf0f1',         // Grigio azzurro chiaro
      paper: '#ffffff',
    },
    text: {
      primary: '#2c3e50',         // Blu scuro
      secondary: '#7f8c8d',       // Grigio
    },
    success: {
      main: '#27ae60',            // Verde
      light: '#58d68d',
      dark: '#1e8449',
    },
    warning: {
      main: '#f39c12',            // Arancione
      light: '#f7b84d',
      dark: '#d68910',
    },
    error: {
      main: '#e74c3c',            // Rosso
      light: '#ec7063',
      dark: '#c0392b',
    },
  },
  rockdreams: {
    primary: {
      main: '#2b3c36',            // Verde scuro come assettoteatro
      light: '#4e625d',
      dark: '#1c2924',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#8B4513',            // Marrone rock
      light: '#a0622a',
      dark: '#5d2e0c',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f4efe9',         // Ocra chiarissimo
      paper: '#ffffff',
    },
    text: {
      primary: '#2b2b2b',         // Neutro scuro
      secondary: '#5f5f5f',       // Grigio caldo
    },
    success: {
      main: '#5f8a3b',            // Verde oliva
      light: '#8dbd63',
      dark: '#3e5c29',
    },
    warning: {
      main: '#e08b27',            // Ocra brillante
      light: '#ffc766',
      dark: '#ab6312',
    },
    error: {
      main: '#b33c3c',            // Rosso vintage
      light: '#e06666',
      dark: '#801b1b',
    },
  }
};

// Configurazioni comuni per tutti i clienti
const commonTheme = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 400,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
  },
};

// Funzione per ottenere il tema del cliente corrente
const getTheme = () => {
  const associate = process.env.REACT_APP_ASSOCIATE;
  
  if (!associate || !palettes[associate]) {
    console.warn(`Palette non trovata per cliente ${associate}, uso palette di default (assettoteatro)`);
    return createTheme({
      ...commonTheme,
      palette: palettes.assettoteatro
    });
  }
  
  return createTheme({
    ...commonTheme,
    palette: palettes[associate]
  });
};

export default getTheme; 